/**
 * A identificação da tela Enviar documentos (E144.F3, GUS-135; E165.F1.T03, HTML 6.8): o número do
 * processo, a pasta e o CPF (ou, no exame de um processo existente, os dele), com o prazo processual
 * e a urgência recolhidos no mesmo card. O mesmo bloco antes e depois de o caso existir e em todos
 * os perfis; o que muda é se os três campos são obrigatórios (a abertura do cliente no fluxo
 * eletrônico). As observações têm card próprio, depois dos arquivos (`ObservacoesDoPedido`).
 */
import type { FormularioDoEnvio } from '@/lib/abertura';
import type { ProcessoData } from '@/lib/processos';

import { IdentificacaoMinima, ProcessoDoExame } from './IdentificacaoMinima';
import { PrazoEUrgencia } from './PedidoDoCliente';
import type { ErrosDoFormulario } from './regrasDoEnvio';

export interface FormularioDaIdentificacaoProps {
  valor: FormularioDoEnvio;
  onChange: (valor: FormularioDoEnvio) => void;
  erros: ErrosDoFormulario;
  /** Os erros do pedido só aparecem depois da primeira tentativa. */
  tentou: boolean;
  /** E165.F1.T03: a abertura do cliente no fluxo eletrônico exige os três campos. */
  obrigatoria: boolean;
  /** O exame de um processo existente, antes de o caso existir: a identificação é a dele. */
  processo?: ProcessoData | undefined;
  disabled: boolean;
}

export function FormularioDaIdentificacao({
  valor,
  onChange,
  erros,
  tentou,
  obrigatoria,
  processo,
  disabled,
}: FormularioDaIdentificacaoProps): JSX.Element {
  const prazo = (
    <PrazoEUrgencia
      valor={valor.pedido}
      onChange={(novo) => onChange({ ...valor, pedido: novo })}
      erro={tentou ? erros.pedido : null}
      disabled={disabled}
    />
  );
  return processo !== undefined ? (
    <ProcessoDoExame processo={processo}>{prazo}</ProcessoDoExame>
  ) : (
    <IdentificacaoMinima
      valor={valor.identificacao}
      onChange={(identificacao) => onChange({ ...valor, identificacao })}
      erros={erros.identificacao}
      obrigatoria={obrigatoria}
      disabled={disabled}
    >
      {prazo}
    </IdentificacaoMinima>
  );
}
